import Permissions from '@/common/permissions';

import useHasAccess from '../useHasAccess';

const useProviderNameVisible = () => {
  const hasAccessToGetNotes = useHasAccess([{ permission: Permissions.VIEW_TRANSACTOR }]);

  return hasAccessToGetNotes;
};

export default useProviderNameVisible;
